export default __webpack_public_path__ + "static/media/Glasses.7300ac16.svg";